/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partner_Activity_Scoped_ToInputs */



/**
* | output |
* | --- |
* | "Showing changes for {name}" |
*
* @param {Partner_Activity_Scoped_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_scoped_to = /** @type {((inputs: Partner_Activity_Scoped_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_Scoped_ToInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Änderungen für ${i?.name}`)
	return /** @type {LocalizedString} */ (`Showing changes for ${i?.name}`)
});